import RouteIcon from "@redotech/redo-icons/route.svg";
import { Provider, getProviderDisplayName } from "@redotech/redo-model/order";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { fgFilterEntries } from "@redotech/redo-model/views/fulfillment/fg-filter-catalog";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.source;

export const OrderSourceFilter: ArrayStringTableFilter<string> = {
  type: entry.type,
  Icon: RouteIcon,
  operators: [...entry.operators],
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "source",
  itemLabelPlural: "sources",
  values: [...entry.staticValues],
  display: (item: string) => getProviderDisplayName(item as Provider),
  displayName: entry.displayName,
};
